module.exports = __webpack_public_path__ + "img/sleeve_flounces_length.680049fb.png";